const ZONE = '/cdn-cgi/image';

interface Option {
  width?: number;
  height?: number;
  fit?: 'scale-down' | 'contain' | 'cover' | 'crop' | 'pad';
  format?: 'auto';
}

/**
 * cloudFlare image format
 * @see https://developers.cloudflare.com/images/image-resizing/url-format/
 * @param imageUrl
 * @param option
 */
export default function applyImageUrlFormat(imageUrl: string, option: Option) {
  if (!imageUrl) {
    return '';
  }

  const optionsEntries = Object.entries({
    quality: 85,
    ...option,
  });

  const query = optionsEntries
    .filter((entry) => {
      const [key] = entry;
      return key !== 'format';
    })
    .map((entry) => {
      const [key, value] = entry;
      return `${key}=${value}`;
    })
    .join(',');

  try {
    const url = new URL(imageUrl);
    return `${url.protocol}//${url.host}${ZONE}/${query}${url.pathname}`;
  } catch (e) {
    return imageUrl;
  }
}
